import { BaseService } from "./base";

export interface AlunoResponse {
  id: string;
  nome: string;
}

export interface TurmaResponse {
  id: string;
  nome: string;
  ano: number;
  alunos?: AlunoResponse[];
}

export interface TurmaImportarItem {
  matricula: string;
  nome: string;
  turma: string;
  ano: number;
}

export interface TurmaImportarResponse {
  toAdd: TurmaImportarItem[];
  toDelete: TurmaImportarItem[];
}

class TurmasService extends BaseService {
  constructor() {
    super("turmas");
  }

  getAll(): Promise<TurmaResponse[]> {
    return this.get("all");
  }

  getByPeriodo(periodoId: string): Promise<TurmaResponse[]> {
    return this.get("all?periodoId=" + periodoId);
  }

  importarPrevia(file: File): Promise<TurmaImportarResponse> {
    const formData = new FormData();
    formData.append("arquivo", file);
    return this.post("upload", formData);
  }

  importarFinal(data: TurmaImportarResponse): Promise<void> {
    return this.patch("upload", data);
  }
}

export default new TurmasService();
